function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GridMouseHandler, GridRange } from '@deephaven/grid';
import { ContextActionUtils } from '@deephaven/components';
class IrisGridCopyCellMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super(250);
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
    this.cursor = null;
  }
  onClick(gridPoint, grid, event) {
    if (event.altKey && !ContextActionUtils.isModifierKeyDown(event) && !event.shiftKey) {
      this.cursor = null;
      if (gridPoint.columnHeaderDepth !== undefined) {
        this.irisGrid.copyColumnHeader(gridPoint.column, gridPoint.columnHeaderDepth);
      } else {
        this.irisGrid.copyRanges([GridRange.makeCell(gridPoint.column, gridPoint.row)]);
      }
      return true;
    }
    return false;
  }
  onMove(gridPoint, _grid, event) {
    if (event.altKey && !ContextActionUtils.isModifierKeyDown(event) && !event.shiftKey && gridPoint.column != null && (gridPoint.row != null || gridPoint.columnHeaderDepth != null)) {
      this.cursor = this.irisGrid.props.copyCursor;
      return true;
    }
    return false;
  }
}
export default IrisGridCopyCellMouseHandler;
//# sourceMappingURL=IrisGridCopyCellMouseHandler.js.map